import { render } from "./PackageEditModal.vue?vue&type=template&id=58bc8f3b"
import script from "./PackageEditModal.vue?vue&type=script&lang=js"
export * from "./PackageEditModal.vue?vue&type=script&lang=js"

import "./PackageEditModal.vue?vue&type=style&index=0&id=58bc8f3b&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__